import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-property-package',
    templateUrl: './property-package.component.html',
    styleUrls: ['./property-package.component.scss']
})

export class PropertyPackageComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<any>) {
    }

    ngOnInit(): void {
    }

    receiveCloseDialog(e) {
        if (e.value) {
            this.dialogRef.close();
        }
    }
}
